import { GridColumnType } from "../../../../data/gridColumnType";

export const ApproveSGBPCategoryCriteriaConfig = {
  columns: [
    {
      name: "Channel",
      fieldName: "channelName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Category (L1)",
      fieldName: "categoryL1Name",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Sub Category (L2)",
      fieldName: "subCategoryL2Name",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Type (L3)",
      fieldName: "typeL3Name",
      colType: GridColumnType.Text,
    },
    {
      name: "Code",
      fieldName: "code",
      colType: GridColumnType.Text,
    },
    {
      name: "Certificate",
      fieldName: "certificate",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "statusName",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      customWrapper: [
          {
              name: "VIEW",
              label: "View",
          },
          // {
          //     name: "ACTIVATE",
          //     label: "Activate",
          // },
          {
              name: "DEACTIVATE",
              label: "Deactivate",
          },
      ],
      defaultAction: {
          allowEdit: false,
          allowDelete: false,
      },
  },
  ],
};
